export default {"src":"/_next/static/media/logo-hertz.f0971325.svg","height":16,"width":41,"blurWidth":0,"blurHeight":0};